var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBAppModeler({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2648 0H9.73519C4.35859 0 0 4.35859 0 9.73519V44.2648C0 49.6414 4.35859 54 9.73519 54H44.2648C49.6414 54 54 49.6414 54 44.2648V9.73519C54 4.35859 49.6414 0 44.2648 0Z",
    fill: "#1E3101"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3584 29.6707C31.3584 22.936 36.3911 19.5688 41.6084 19.5688C42.3115 19.5688 43.0518 19.6428 43.4956 19.717V13.6484H49.9707V37.9592C48.417 38.7363 45.3457 39.5503 42.0156 39.5503C36.3174 39.5503 31.3584 36.3311 31.3584 29.6707ZM43.4956 34.148V25.0823C43.0518 24.9343 42.4966 24.8233 41.7564 24.8233C39.7212 24.8233 37.834 26.0073 37.834 29.5596C37.834 32.8159 39.5361 34.2959 41.7935 34.2959C42.3115 34.2959 43.0147 34.259 43.4956 34.148Z",
    fill: "#99E83F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6143 14.5266L16.9077 26.2664L20.5154 14.481H28.2488L29.7476 39.2173H23.124L22.791 29.7817C22.7168 27.4136 22.6431 25.0454 22.5693 22.6401L18.832 37.2932H14.3916L11.0982 23.3801C10.9873 25.5264 10.9131 27.6724 10.8389 29.7817L10.3955 39.2173H4.17871L5.80664 14.5266L13.6143 14.5266Z",
    fill: "#99E83F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBAppModeler);
export default __webpack_public_path__ + "static/media/B_app_Modeler.96c430ed8d7995e3c3539bb8c4338f9e.svg";
export { ForwardRef as ReactComponent };